<template>
    <v-col md="12" xs="8" sm="10" style="height: 93vh;">
        <v-row justify="center" style="margin: 0 auto; max-width: 1000px">
            <v-col md="4" xs="2" sm="3">
                <v-row>
                    <h2>Pago con Tarjeta</h2>
                </v-row>
                <v-row>
                    <p2>Número de Tarjeta</p2>
                </v-row>
                <v-row>
                    <v-text-field label="" solo v-model="cardNumber"  :rules="rules" :counter="10" required single-line hide-details>      
                    </v-text-field>
                </v-row>
                <v-row>
                    <h2><br></h2>
                </v-row>
                <v-row>
                    <v-col>
                        <v-row>
                            <p2>Tipo de Tarjeta</p2>
                        </v-row>    
                        <v-row>
                            <v-text-field label="" solo v-model="cardType"  :rules="rules" :counter="10" required single-line hide-details>      
                            </v-text-field>
                        </v-row>  
                    </v-col>                 
                </v-row>
                <v-row>
                    <h2><br></h2>
                </v-row>
                <v-row md="4">
                    <h2>Medios Digitales</h2>
                </v-row>
                <v-row class="pt-2">
                    <v-img @click="$router.push({ name: 'confirm'});" max-width="150px" src="../assets/payments.png"></v-img>
                </v-row>
            </v-col>
            <v-col md="1" xs="1" sm="1">
            </v-col>
            <v-col md="4" xs="4" sm="4">
                <v-row>
                    <h2><br></h2>
                </v-row>
                <v-row>
                    <p2>Nombre en la Tarjeta</p2>
                </v-row>
                <v-row>
                    <v-text-field label="" solo v-model="cardName"  :rules="rules" :counter="10" required single-line hide-details>      
                    </v-text-field>
                </v-row>
                <v-row>
                    <h2><br></h2>
                </v-row>
                <v-row>
                    <v-col>
                        <v-row>
                            <p2>Vigencia</p2>
                        </v-row>    
                        <v-row>
                            <v-text-field label="" solo v-model="validity"  :rules="rules" :counter="10" required single-line hide-details>      
                            </v-text-field>
                        </v-row>                   
                    </v-col>
                    <v-col md="1"> 
                    </v-col>
                    <v-col>
                        <v-row>
                            <p2>CVC</p2>
                        </v-row>  
                        <v-row>
                            <v-text-field label="" solo v-model="cvc"  :rules="rules" :counter="10" required single-line hide-details>      
                            </v-text-field>
                        </v-row>  
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
    </v-col>
</template>
<script>
export default {
    data: function()
    {
        return{
            cardType:'',
            validity:'',
            cardNumber:'',
            cardName:'',
            cvc:'',
            rules: [
                v => !!v || 'Name is required',
                v => v.length <= 10 || 'Name must be less than 10 characters',
            ],
        }
    }
}
</script>
<style scoped>

</style>